
import {useState} from "react";

const useOrderValidate = () => {
    const [personInfo, setPersonInfo] = useState({
        name: '',
        surname:'',
        email:'',
        phone:'',
        profession:'',
        brand: '',
        messageText:''
    })
    const [errorText, setErrorText] = useState({
        name: '',
        email: '',
        brand: '',
        profession: ''
    })

    const validateMail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    const phoneRegex = /^\d{10}$/;

    const validation = () => {
        let validate = true
        let errorString = {
            name: '',
            email: '',
            brand: '',
            profession: ''
        }
        if (!personInfo.name.trim().length) {
            validate = false
            errorString.name = "Fill in the required FirstName"
        }
        if (!personInfo.email.trim().length) {
            validate = false
            errorString.email = "Fill in the required EmailAddress"

        } else if (!validateMail.test(personInfo.email)) {
            validate = false
            errorString.email = "Fill in the email"
        }
        if (!personInfo.phone.trim().length) {
            validate = false
            errorString.phone = "Fill in the required Password"

        }else if(personInfo.phone && personInfo.phone.length < 9){
            validate = false
            errorString.phone = "Fill in the required Password"

        }

        if (!personInfo.brand.trim().length) {
            validate = false
            errorString.brand = "Fill in the required ConfirmPassword"

        }
        if (!personInfo.profession.trim().length ) {
            validate = false
            errorString.profession = "l to each other"
        }
        setErrorText(errorString)
        return validate
    }

    return {validation, personInfo, setPersonInfo, errorText, setErrorText}
}

export default useOrderValidate